import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl" aria-hidden="true"></i>
      </span>
      <p className="mt-6 font-heading font-extrabold text-6xl md:text-8xl text-primary-500">404</p>
      <h1 className="mt-3 font-heading font-bold text-xl text-foreground-950">这个页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的地址 <span className="text-foreground-700">{location.pathname}</span> 不存在或已被移除。
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-1.5 h-11 px-6 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
      >
        <i className="ri-home-4-line" aria-hidden="true"></i>
        返回首页
      </Link>
    </div>
  );
}